var exports = {
  "gP": "EmbedVideo.module__videoOverlay___X0tpU0",
  "yH": "EmbedVideo.module__playButtonWrapper___X0tpU0",
  "SK": "EmbedVideo.module__thumbnailPlaceholder___X0tpU0",
  "aO": "EmbedVideo.module__thumbHashPlaceholder___X0tpU0",
  "mZ": "EmbedVideo.module__metadataProbe___X0tpU0",
  "tN": "EmbedVideo.module__blurContainer___X0tpU0",
  "rj": "EmbedVideo.module__blurContent___X0tpU0",
  "UF": "EmbedVideo.module__blurInner___X0tpU0",
  "Y3": "EmbedVideo.module__blurThumbnail___X0tpU0",
  "il": "EmbedVideo.module__mediaContainer___X0tpU0",
  "AA": "EmbedVideo.module__mobileContainer___X0tpU0",
  "SY": "EmbedVideo.module__videoPlayerWrapper___X0tpU0",
  "s": "EmbedVideo.module__videoPlayerBlock___X0tpU0",
  "Qh": "EmbedVideo.module__videoPlayerFill___X0tpU0",
  "hz": "EmbedVideo.module__inlineVideo___X0tpU0",
  "nD": "EmbedVideo.module__inlineMuteButton___X0tpU0",
};

module.exports = exports;
